import {
  Component,
  OnInit,
  ContentChild,
  Input,
  ApplicationRef,
} from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { CustomdatepickerComponent } from "../../../../shared/modules/customdatepicker.component";
import { EContactLogMethod } from "app/modules/api/model/eContactLogMethod";
import { ContactLogService } from "app/modules/api/api/contactLog.service";
import { PurposeService } from "app/modules/api/api/purpose.service";

@Component({
  selector: "app-contact-log",
  templateUrl: "./contact-log.component.html",
  styleUrls: ["./contact-log.component.scss"],
})
export class ContactLogComponent implements OnInit {
  @Input() detail;
  @Input() customerId;
  @Input() id;
  @ContentChild(CustomdatepickerComponent)
  datepickerViewChild: CustomdatepickerComponent;
  update: boolean = false;
  caseId = null;
  today = new Date();
  listPurpose = [];
  listCaseId = []
  logForm: FormGroup;
  loading = false;
  minDate = {
    year: this.today.getFullYear(),
    month: this.today.getMonth() + 1,
    day: this.today.getDate(),
  };
  contactLogMethodList = [
    { value: EContactLogMethod.Chat, label: "Chat" },
    { value: EContactLogMethod.Email, label: "Email" },
    { value: EContactLogMethod.PhoneCall, label: "Phone Call" },
    { value: EContactLogMethod.Sms, label: "Sms" },
  ];

  constructor(
    public activeModal: NgbActiveModal,
    private cl: ContactLogService,
    private ps: PurposeService,
    private app: ApplicationRef
  ) {}

  ngOnInit() {
    let dt = new Date();
    const date = {
      year: dt.getFullYear(),
      month: dt.getMonth() + 1,
      day: dt.getDate(),
    };
    const time = {
      hour: dt.getHours(),
      minute: dt.getMinutes(),
    };
    this.logForm = new FormGroup({
      note: new FormControl(),
      time: new FormControl(time),
      date: new FormControl(date),
      name: new FormControl(null, [Validators.required]),
      purpose: new FormControl(null, [Validators.required]),
      method: new FormControl(EContactLogMethod.PhoneCall, [
        Validators.required,
      ]),
    });
    if (this.detail.customerId) {
      this.logForm.addControl('case', new FormControl(null, [Validators.required]));
    }
    if (this.id) {
      this.cl.apiContactLogIdGet(this.id).subscribe((data) => {
        const contactDate = new Date(data.contactDate * 1000);
        this.logForm.patchValue({
          note: data.note,
          name: data.contactedBy,
          purpose: data.purposeId,
          case: data.caseId,
          method: data.method,
          date: {
            year: contactDate.getFullYear(),
            month: contactDate.getMonth() + 1,
            day: contactDate.getDate(),
          },
          time: {
            hour: contactDate.getHours(),
            minute: contactDate.getMinutes(),
          },
        });
      });
    }
    this.name.setValue(JSON.parse(localStorage.getItem("currentUser")).name);
    this.getPurpose();
    this.getCaseByCustomerId()
  }
  get note() {
    return this.logForm.get("note");
  }
  get time() {
    return this.logForm.get("time");
  }
  get date() {
    return this.logForm.get("date");
  }
  get name() {
    return this.logForm.get("name");
  }
  get purpose() {
    return this.logForm.get("purpose");
  }
  get case() {
    return this.logForm.get("case");
  }
  get method() {
    return this.logForm.get("method");
  }
  validateForm(logForm: FormGroup) {
    Object.keys(logForm.controls).forEach((field) => {
      const control = logForm.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateForm(control);
      }
      this.app.tick();
    });
  }
  closeModal() {
    this.activeModal.dismiss("close");
  }
  saveModal() {
    if (this.logForm.valid) {
      const date = new Date(
        this.date.value.year,
        this.date.value.month - 1,
        this.date.value.day,
        this.time.value.hour,
        this.time.value.minute
      );
      const data = {
        contactDate: Math.floor(date.getTime() / 1000),
        note: this.note.value,
        contactedBy: this.name.value,
        purposeId: this.purpose.value,
        method: this.method.value,
        caseId: this.detail.caseId ? this.detail.caseId : this.case.value,
        customerId: this.customerId,
      };
      this.activeModal.close(data);
    } else {
      this.validateForm(this.logForm);
    }
  }
  getPurpose() {
    this.ps.apiPurposeGet().subscribe((data) => {
      this.listPurpose = data.filter((item) => item.isActive === true);
    });
  }
  getCaseByCustomerId() {
    this.cl.apiContactLogGetCasesByCustomerIdIdGet(this.customerId).subscribe((data) => {
      this.listCaseId = data
    });
  }
}
